import React, { useState } from 'react'
import { FundAffectation } from '../../../models/Portfolio'
import { Box, ITheme, Typography, useTheme } from '@mui/material'
import FundSelectionListItem from './FundSelectionListItem'
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';

export interface IFundSelectionListProps {
  portfolioName?: string;
  portfolioSize?: number;
  funds: FundAffectation[];
  hideRemove?: boolean;
  isDroppable?: boolean;
  onDrop?: (event: React.DragEvent<HTMLDivElement>) => void;
  fundsListRef?: React.RefObject<HTMLDivElement>;
}

const FundSelectionList: React.FC<IFundSelectionListProps> = ({ portfolioName, portfolioSize, funds, hideRemove, isDroppable, onDrop, fundsListRef }) => {
  const theme = useTheme() as ITheme;
  const {t} = useTranslation();

  const onDragOver = (event: React.DragEvent<HTMLDivElement>) =>{
    event.preventDefault();
  }

  return <Box display={"flex"} flexDirection={"column"} gap={"8px"} onDrop={isDroppable ? onDrop : undefined} onDragOver={isDroppable ? onDragOver : undefined} ref={fundsListRef}>
    {funds.map((f, i) => (<FundSelectionListItem fund={f} index={i} key={`selected-fund-${f.id}`} hideRemove={hideRemove} allocation={portfolioSize ? portfolioSize * f.proportion : undefined} />))}
    {(funds.length === 0 || isDroppable) && <Box display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"} height={"100px"} width={"100%"} border={`1px dotted ${theme.palette.leo.type[400]}`}>
      <Typography fontSize={"16px"} lineHeight={"12px"} fontWeight={"600"} color={theme.palette.leo.type[400]}>{t('CreatePortfolioAddFundsTo')} {portfolioName}</Typography>
        <AddIcon sx={{ color: theme.palette.leo.type[400]}} />
      </Box>}
  </Box>
}

export default FundSelectionList